export const userGroups = {
    SuperAdmin: 'Super Admin',
    SystemAdmin: 'System Admin',
    EnterpriseAdmin: 'Enterprise Admin',
    TeamAdmin: 'Team Admin',
    Champion: 'Champion',
    User: 'User'
}